import baseApi from '@store/api/baseApi';

export const sampleDevelopmentApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		submitSampleRequest: builder.mutation({
			query: ({ body, params }) => ({
				url: '/sample/request',
				method: 'POST',
				body,
				params
			})
		}),
		sampleUpdate: builder.mutation({
			query: ({ body, params }) => ({
				url: '/sample/update',
				method: 'PUT',
				body,
				params
			})
		}),

		getProductInfoByIds: builder.query({
			query: ({ params }) => ({
				url: '/product/get-info',
				params
			})
		}),
		updateSampleRequest: builder.mutation({
			query: ({ body, params, sampleItemId }) => ({
				url: `/sample/item/${sampleItemId}`,
				method: 'PUT',
				body,
				params
			}),
			invalidatesTags: ['GET_SAMPLE_ITEM_BY_ID']
		}),
		cancelSampleRequest: builder.mutation({
			query: ({ body, sampleItemId }) => ({
				url: `/sample/item/${sampleItemId}/cancel-item`,
				method: 'POST',
				body
			})
		}),
		getSampleRequestByProductId: builder.query({
			query: ({ sampleIds = [] }) => ({
				url: `/sample/item/list?ids=${sampleIds?.join(',')}`
			}),
			providesTags: ['GET_SAMPLE_ITEM_BY_ID']
		}),
		updateBuyerSampleById: builder.mutation({
			query: ({ body, sampleId }) => ({
				url: `/sample/item/${sampleId}`,
				method: 'PUT',
				body
			})
		}),
		getSampleInventory: builder.query({
			query: ({ params }) => ({
				url: `/sample-inventory-request/get-sample_inventory_bd`,
				params
			}),
			providesTags: ['GET_SAMPLE_INVENTORY_BD']
		}),
		submitPhysicalSampleRequest: builder.mutation({
			query: ({ body }) => ({
				url: `/sample-inventory-request/`,
				method: 'POST',
				body
			})
		}),
		getProjectDealList: builder.query({
			query: ({ params }) => ({
				url: '/rfq/available-deals',
				params
			})
		})
	})
});

export const {
	useSampleUpdateMutation,
	useGetProductInfoByIdsQuery,
	useSubmitSampleRequestMutation,
	useUpdateSampleRequestMutation,
	useCancelSampleRequestMutation,
	useGetSampleRequestByProductIdQuery,
	useUpdateBuyerSampleByIdMutation,
	useGetSampleInventoryQuery,
	useSubmitPhysicalSampleRequestMutation,
	useGetProjectDealListQuery
} = sampleDevelopmentApi;
